module.exports = require("../../_gen/openfl/globalization/LocaleID");